import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { openGuide } from './annaBus';

/** Old links to the Help & FAQ page land on the dashboard with the guides open. */
const GuidesRedirect = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/admin/dashboard', { replace: true });
    // Let the dashboard render before the guides open over it.
    const timer = setTimeout(() => openGuide(), 50);
    return () => clearTimeout(timer);
  }, [navigate]);
  return null;
};

export default GuidesRedirect;
